import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../SidebarAdmin/Sidebar.js";

function LatestAdminLayout({ session }) {
    const [collapsed, setCollapsed] = useState(window.innerWidth < 1024);

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            <div className="flex flex-col flex-1">
                {/* <FranchiseHeader onToggle={() => setCollapsed(!collapsed)} session={session} /> */}
                <main className="flex-1 md:p-4 py-4 overflow-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export default LatestAdminLayout;
